export enum ContactsType {
  SMS = "SMS",
  EMAIL = "EMAIL",
}
